import { FlatSheet } from './FlatSheet';

export type { TypeFlatSheetProps } from './types';
export default FlatSheet;
